import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { userApi } from "redux/user/api";
import { STORAGE_AUTH_TOKEN } from "constants/variables";
import { API_TAGS } from "constants/apiTags";
import {
  AuthResponseType,
  LoginRequestType,
  RegisterRequestType,
} from "types/Auth";
import { setLocalStorageItem } from "utils/localStorage";
import url from "url/index";
import { setServiceError } from "stores/settings";
import { setHostname } from "utils/hostname";
import { setCredential, setHeaders } from "utils/credential";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: setHostname(),
    credentials: setCredential(),
    prepareHeaders: setHeaders,
  }),
  tagTypes: [API_TAGS.PAYMENTS],

  endpoints: (build) => ({
    register: build.mutation<AuthResponseType, RegisterRequestType>({
      query: (request: RegisterRequestType) => ({
        url: url.config.api.auth.register,
        method: "POST",
        body: request,
        params: {
          r: request.r,
        },
      }),
      async onQueryStarted(
        request: RegisterRequestType,
        { dispatch, queryFulfilled, getState },
      ) {
        try {
          const { data } = await queryFulfilled;
          if (data.statusCode === 200) {
            setLocalStorageItem(STORAGE_AUTH_TOKEN, data.authToken);
            setLocalStorageItem("phoneTriggerStatus", "1");
            await userApi.endpoints.getProfile.initiate("", {
              forceRefetch: true,
            })(dispatch, getState, "");
          }
          if (data.statusCode >= 500) {
            setServiceError(true);
          }
        } catch (error: any) {
          if (error.statusCode >= 500) {
            setServiceError(true);
          }
        }
      },
    }),
    login: build.mutation<AuthResponseType, LoginRequestType>({
      query: (request: LoginRequestType) => ({
        url: url.config.api.auth.login,
        method: "POST",
        body: request,
      }),
      invalidatesTags: [API_TAGS.PAYMENTS],
      async onQueryStarted(
        request: LoginRequestType,
        { dispatch, queryFulfilled, getState },
      ) {
        try {
          const { data } = await queryFulfilled;
          if (data.statusCode === 200) {
            setLocalStorageItem(STORAGE_AUTH_TOKEN, data.authToken);
            await userApi.endpoints.getProfile.initiate("", {
              forceRefetch: true,
            })(dispatch, getState, "");
          }
          if (data.statusCode >= 500) {
            setServiceError(true);
          }
        } catch (error: any) {
          if (error.statusCode >= 500) {
            setServiceError(true);
          }
        }
      },
    }),
  }),
});
